import React, { Component } from "react";
import { connect } from "react-redux";
import { alert } from "../actions/alerts";

const initialState = {
  loading: false,
  status: null,
};

export default () =>
  (
    ComposedComponent
    // Do we want this?
    // capture error message
  ) =>
    @connect()
    class extends Component {
      state = initialState;

      reset = () => {
        this.setState(initialState);
      };

      uiAction = async (promise, { showErrors = true } = {}) => {
        const { dispatch } = this.props;

        this.setState({ loading: true });
        try {
          const res = await promise;
          if (res && res.error) throw new Error(res.error.message);

          if (!this.mounted) return res;
          this.setState({ loading: false, status: "ok" });
          return res;
        } catch (err) {
          if (showErrors) {
            dispatch(alert({ message: err.message, type: "error" }));
          }
          if (!this.mounted) return;
          this.setState({ loading: false, status: "fail" });
        }
      };

      componentDidMount() {
        this.mounted = true;
      }

      componentWillUnmount() {
        this.mounted = false;
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            ui={this.state}
            uiAction={this.uiAction}
            uiReset={this.reset}
          />
        );
      }
    };



// WEBPACK FOOTER //
// ./app/containers/withLoading.js